import {
  fetchDeveloperTokenAPI,
  updateDeveloperTokenAPI,
} from "../infrastructure/developer-api-token";

export async function fetchDeveloperToken(referenceId: number): Promise<string | undefined> {
  return await fetchDeveloperTokenAPI(referenceId);
}

export async function updateDeveloperToken(referenceId: number): Promise<string | undefined> {
  return await updateDeveloperTokenAPI(referenceId);
}
